__webpack_require__.p = "https://cdn.qantashotels.com/qantashotelsui/_next/";